module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor22-c11e088a093f97485a32154de50a5529.png";